const getters = {
  permission_routers: state => state.role.routers,
  addRouters: state => state.role.addRouters,
  role: state => state.role.role,
  permissions: state => state.role.permission,
  roles: state => state.role.roles,
  roleMenus: state => {
    const roles = state.role.roles;
    let menus = {};
    roles.forEach(role => {
      menus[role.id] = role.name;
    });
    return menus;
  }
};
export default getters;
